import { useLocation, useNavigate } from 'react-router-dom';

const useQueryString = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryString = new URLSearchParams(location.search);

  const setQueryString = (params: Record<string, any>) => {
    const newQueryParams = new URLSearchParams(location.search);
    Object.keys(params).forEach((key) => {
      const value = params[key];
      if (value === null || value === undefined || value === '' || (Array.isArray(value) && !value.length)) {
        newQueryParams.delete(key);
      } else {
        newQueryParams.set(key, String(value));
      }
    });
    navigate({ search: newQueryParams.toString() }, { replace: true });
  };
  return { queryString, setQueryString } as const;
};

export default useQueryString;
